import { render, staticRenderFns } from "./ExerciseView.vue?vue&type=template&id=90b93446&scoped=true&"
import script from "./ExerciseView.vue?vue&type=script&lang=js&"
export * from "./ExerciseView.vue?vue&type=script&lang=js&"
import style0 from "./ExerciseView.vue?vue&type=style&index=0&id=90b93446&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90b93446",
  null
  
)

export default component.exports